import i18n from "i18next";
import { initReactI18next } from "react-i18next";


const resources = {
  en: {
    translation: {
      "Welcome to React": "Welcome to React and react-i18next",
      "msg.jkaProfessors": "Teacher",
      "msg.jkaAffiliates": "Affiliates",
      "msg.jkaCourses": "Courses",
      "msg.jkaName": "Name",
      "msg.jkaState": "JKA Estadual",
      "msg.jkaReferees": "Referees",
  "msg.jkaAnnuity": "Annuity",
  "msg.jkaActive": "Ativo",



  

      "msg.jkaPaidAnnuity": "Paid",
      "msg.jkaUnpaidAnnuity": "Unpaid",
      "currentPageReportTemplate": "Exibindo {first} a {last} de {totalRecords} professores",
      "currentPageReportTemplateAffiliates": "Exibindo {first} a {last} de {totalRecords} associados",
      "currentPageReportTemplateCourses": "Exibindo {first} a {last} de {totalRecords} cursos"


    }
  },
  pt_br: {
    translation: {
      "Welcome to React": "Welcome to React and react-i18next",
      "msg.jkaTeacherNotAffiliate": "Nome do professor não filiado",
      "msg.jkaProfessors": "Professores",
      "msg.jkaInstructors": "Instrutores",
      "msg.jkaExaminers": "Examinadores",
      "msg.jkaAffiliates": "Associados",
      "msg.jkaAllRegister": "Todos",
      "msg.jkaActiveAffiliates": "Ativos",
      "msg.jkaActiveAssociateAffiliates": "Associados Ativos",
      "msg.jkaBlackBelts": "Faixas Pretas",
      "msg.jkaBlackBeltsState": "Faixas Pretas por estadual selecionada",
      "msg.jkaBlackBeltsByName": "Faixas Pretas selecionados por nome",
      "msg.jkaAllByState": "Todos por estadual selecionada",
      "msg.jkaGyms": "Dojos",
      "msg.jkaGymsAffiliate": "Filiados",
      "msg.jkaGymsNotAffiliate": "Não filiados",
      "msg.jkaAffiliatesByState": "Selecionados por estadual",
      "msg.jkaAffiliatesByName": "Selecionados por nome",
        "msg.jkaAffiliatesByJkaId": "Selecionados por JKA Id",

      "msg.jkaAllGymsAffiliateByState": "Filiados ordenados por estadual",
      "msg.jkaGymsAffiliateByState": "Filiados por estadual selecionada",

      
      "msg.jkaAnnuityforAllDojos": "Insira ano, data e selecione Estadual a inserir anuidade para todos Dojos",
      "msg.jkaClass": "Classe",
      "msg.jkaGym": "Dojo",
      "msg.jkaCourses": "Cursos",

      "msg.jkaReferees": "Árbitros",

      "msg.jkaInstructors": "Instrutores",
      "msg.jkaExaminers": "Examinadores",
      "msg.jkaShihankai": "Shihankai",
    
      "msg.jkaState": "Estadual",

      "msg.jkaName": "Nome",
      "msg.jkaTradeName": "Nome fantasia",
      "msg.jkaBirthDate": "Data de nascimento",
      "msg.jkaDoc": "Identidade",
      "msg.jkaDocId": "CPF",
      "msg.jkaOccupation":  "Profissão",

      "msg.jkaProfessor": "Professor",
      "msg.jkaAnnuity": "Anuidade",
      "msg.jkaActive": "Ativo",
    "msg.jkaInactive": "Inativo",
      "msg.jkaGrade": "Graduação",
      "msg.jkaPhone": "Telefone",
      "msg.jkaPhone1": "Telefone 2",
      "msg.jkaMobile": "Celular",
      "msg.jkaStreetAddress": "Logradouro",
      "msg.jkaStreetAddressNumber": "Número",

      "msg.jkaDate": "Data",
      "msg.jkaIdBR": "Registro JKA BR",
      "msg.jkaIdBRNumber": "Número JKA Br",
      "msg.jkaPassport": "Passaporte",
      "msg.jkaJpId": "Numero JKA Japão",
      "msg.jkaJpRecord": "Prontuário JKA Japão",


      "msg.jkaEmail": "email",
      "msg.jkaNote": "Observação",


      "msg.jkaAffiliateAnnuities": "Anuidades",
      "msg.jkaInstructorLicense": "Licenças de Instrutor",
      "msg.jkaExaminerLicense": "Licenças de Examinador",
      "msg.jkaJudgeLicense": "Licenças de Arbitragem",
      "msg.jkaLicenseClass": "Classe",
      "msg.jkaLicenseRegistrationId": "Numero de registro",
      "msg.jkaLicenseAquisitionYear": "Data de emissão",
      "msg.jkaLicenseValid": "Data de validade",

      "msg.jkaDanExams": "Exames de Dan",
      "msg.jkaExamDate": "Data do exame",
      "msg.jkaDan": "Dan",

      "msg.jkaGymList": "Lista completa de academias",
      "msg.jkaBlackBeltDanListExcel": "Excel com lista completa de faixa pretas e dans",
      "msg.jkaBlackBeltDanList": "Lista completa de faixa pretas e dans",
      "msg.jkaJudgesClassList": "Lista completa de juízes e classes",
      "msg.jkaExaminersClassList": "Lista completa de examinadores e classes",
      "msg.jkaInstructorsClassList": "Lista completa de instrutores e classes",
      "msg.jkaShihankaiList": "Lista dos integrantes do Shihankai",
      "msg.jkaUpdateGymsGeoCode": "Atualizar Geo codes das academias",
      "msg.jkaUpdateJudgesGeoCode": "Atualizar Geo codes dos Arbitros",


      "msg.jkaAddress": "Endereço",
      "msg.jkaMailingAddress": "Endereço Jurídico e Correspondência",

      "msg.jkaLicense": "Alvará",
      "msg.jkaEditLicense": "Editar alvará",
      "msg.jkaYear": "Ano",
      "msg.jkaLicenseIssueDate": "Data de emissão",
      "msg.jkaAddAnnuity": "Inserir anuidade",
      "msg.jkaEditAnnuity": "Editar anuidade",

      "msg.jkaAnnuityPaymentDate": "Data de pagamento",
       "msg.jkaCardIssueDate": "Data emissão carteirinha",

       "msg.jkaCardList": "Ano para emissão de lista de carteirinhas",
       "msg.jkaGenerateFile": "Gerar arquivo",

       "msg.jkaValue": "Valor",


  
      "msg.jkaResponsibles": "Professores responsáveis",
      "msg.jkaResponsible": "Professor responsável",


      "msg.jkaResponsibleAdd":  "Responsavel adicionado mas não gravada. Para gravar clicar em salvar para gravar todos os dados",
      "msg.jkaTechnicalResponsibleAdd":  "Responsável técnico adicionado mas não gravado. Para gravar clicar em salvar para gravar todos os dados",


      "msg.jkaLicenseAdd": "Licença adicionada mas não gravada. Para gravar clicar em salvar para gravar todos os dados",
      "msg.jkaAffiliateAnnuityAdd": "Anuidade adicionada mas não gravada. Para gravar clicar em salvar para gravar todos os dados",
      
      "msg.jkaDanExamAdd":  "Exame adicionado mas não gravado. Para gravar clicar em salvar para gravar todos os dados",
      
      "msg.jkaSuccessful" : "Sucesso",
      "msg.jkaAffiliateUpdated": "Associado alterado",
      "msg.jkaAffiliateCreated": "Associado criado",
      "msg.jkaTeacherCreated": "Professor criado",
      "msg.jkaShihankaiMemberAdded": "Membro do Shihankai adicionado",

      "msg.jkaPaidAnnuity": "Paga",
      "msg.jkaUnpaidAnnuity": "Pendente",
      "currentPageReportTemplate": "Exibindo {first} a {last} de {totalRecords} professores",
      "currentPageReportTemplateExaminers": "Exibindo {first} a {last} de {totalRecords} examinadores",
      "currentPageReportTemplateInstructors": "Exibindo {first} a {last} de {totalRecords} instrutores",
      "currentPageReportTemplateJudes": "Exibindo {first} a {last} de {totalRecords} árbitros",
      "currentPageReportTemplateAffiliates": "Exibindo {first} a {last} de {totalRecords} associados",
      "currentPageReportTemplateCourses": "Exibindo {first} a {last} de {totalRecords} cursos",
      "currentPageReportTemplateGyms": "Exibindo {first} a {last} de {totalRecords} dojos"

    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "pt_br", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;